module.exports = __webpack_public_path__ + "a6f0361c9056636e2581509f4b69cc45.svg";